









import { Component, Vue } from 'vue-property-decorator'
import { Image } from '@/interfaces/GeneralInterfaces'
import { Getter } from 'vuex-class'

@Component({ name: 'GuestLogos' })
export default class GuestLogos extends Vue {
  @Getter('guestLogo/getLogos')
  items!: Image[]
}
